import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => (
  <div className="min-h-screen bg-[#0e0e0e] text-white px-4 py-8">
    <div className="max-w-2xl mx-auto">
      <Link to="/login" className="text-red-500 hover:text-red-400 text-sm mb-6 inline-block">← Back to Login</Link>
      <h1 className="text-2xl font-bold text-red-500 mb-6">Privacy Policy</h1>
      <div className="text-white/80 space-y-4 leading-relaxed text-sm">
        <p>Last updated: {new Date().toLocaleDateString()}</p>
        <p>HubTune ("we", "our", or "us") respects your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you use our platform.</p>
        <h2 className="text-lg font-semibold text-white mt-6">Information We Collect</h2>
        <p>We collect information you provide directly (name, email, profile data) and usage data to improve our services.</p>
        <h2 className="text-lg font-semibold text-white mt-6">How We Use Your Information</h2>
        <p>We use your information to operate the platform, process transactions, send notifications, and improve user experience.</p>
        <h2 className="text-lg font-semibold text-white mt-6">Payments and Payment Gateway</h2>
        <p>Payments on HubTune are processed securely through an authorized third-party payment gateway (PayU). HubTune does not store users&apos; card details, net banking passwords, or other sensitive banking credentials.</p>
        <p>We may share limited required information with our payment partners only for transaction processing, fraud prevention, and legal compliance. This may include basic identification details, transaction amounts, and timestamps.</p>
        <p>Artists may be required to complete identity (KYC) verification before receiving payouts. User data is retained only as long as necessary for legal, audit, and operational purposes, after which it is deleted or anonymized where possible.</p>
        <h2 className="text-lg font-semibold text-white mt-6">Contact</h2>
        <p>
          You can contact HubTune at:
        </p>
        <p className="space-y-1">
          <span className="block"><span className="font-semibold">Name:</span> Ayush Kumar</span>
          <span className="block"><span className="font-semibold">Office Address:</span> 4351, Gali Number 8, Ajit Nagar, Gandhi Nagar, East Delhi, Delhi – 110031, India</span>
          <span className="block">
            <span className="font-semibold">Email:</span>{" "}
            <a
              href="mailto:ayushk76596@gmail.com"
              className="text-red-400 hover:text-red-300 underline"
            >
              ayushk76596@gmail.com
            </a>
          </span>
          <span className="block">
            <span className="font-semibold">Phone:</span>{" "}
            <a
              href="tel:+917080176462"
              className="text-red-400 hover:text-red-300 underline"
            >
              +91 7080176462
            </a>
          </span>
        </p>
      </div>
    </div>
  </div>
);

export default Privacy;
